/* =====================================================================
   DeckWächter · dwx.js — Modern-Schicht 2026-10
   1) Effekte (Scroll-Fortschritt, Reveal, Tilt)
   2) Mengen-Regler  [data-dwx-cfg]   (Toploader-Sets 1–10)
   3) Prämien-Leiste  (Gratis-Geschenke ab 30 / 50 / 100 €)
   Konfiguration der Geschenke: Block RW unten (Varianten-IDs aus dem
   Geschenk-Produkt „gratisgeschenk“, Schwellen in Cent).
   ===================================================================== */
(function () {
  'use strict';
  if (window.DWX) return;
  var D = document, W = window;
  var DWX = W.DWX = {};
  var REDUCE = !!(W.matchMedia && W.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var FINE = !!(W.matchMedia && W.matchMedia('(hover:hover) and (pointer:fine)').matches);
  var _fetch = W.fetch ? W.fetch.bind(W) : null;

  /* ---------- Hilfen ---------- */
  function eur(c) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; }
  function $(s, r) { return (r || D).querySelector(s); }
  function $$(s, r) { return [].slice.call((r || D).querySelectorAll(s)); }
  var SV = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">';
  var ICON = {
    ship: SV + '<path d="M2.5 6.5h11v9h-11z"/><path d="M13.5 9.5h4l3 3.2v2.8h-7z"/><circle cx="7" cy="17.5" r="1.9"/><circle cx="17" cy="17.5" r="1.9"/></svg>',
    sleeves: SV + '<rect x="4" y="5.5" width="11" height="15" rx="2"/><path d="M8 3h9a3 3 0 0 1 3 3v10"/></svg>',
    cards: SV + '<rect x="3.5" y="6" width="10" height="14" rx="1.8" transform="rotate(-10 8.5 13)"/><rect x="10" y="4.5" width="10" height="14" rx="1.8" transform="rotate(8 15 11.5)"/></svg>',
    toploader: SV + '<rect x="5" y="2.5" width="14" height="19" rx="2.2"/><rect x="8" y="6.5" width="8" height="11" rx="1.2"/><path d="M9.5 4.6h5"/></svg>',
    gift: SV + '<rect x="3.5" y="9" width="17" height="11.5" rx="1.8"/><path d="M12 9v11.5M3.5 13.5h17"/><path d="M12 9c-1.2-3.4-5-3.8-5-1.4S10 9 12 9zm0 0c1.2-3.4 5-3.8 5-1.4S14 9 12 9z"/></svg>',
    check: SV + '<path d="M5 12.5l4.2 4.2L19 7"/></svg>'
  };
  DWX.icon = ICON; DWX.eur = eur;

  /* ---------- Toast ---------- */
  var toastEl, toastT;
  DWX.toast = function (html, ms) {
    if (!toastEl) { toastEl = D.createElement('div'); toastEl.className = 'dwx-toast'; toastEl.setAttribute('role', 'status'); D.body.appendChild(toastEl); }
    toastEl.innerHTML = html; toastEl.classList.add('is-on');
    clearTimeout(toastT); toastT = setTimeout(function () { toastEl.classList.remove('is-on'); }, ms || 4200);
  };

  /* ---------- Warenkorb-Hilfen ---------- */
  DWX.cartJson = function () { return _fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' }).then(function (r) { return r.json(); }); };
  DWX.refreshBubble = function () {
    return _fetch('/?sections=cart-icon-bubble', { cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (j) {
      var h = j && j['cart-icon-bubble']; if (!h) return;
      var t = D.createElement('div'); t.innerHTML = h;
      var src = $('#cart-icon-bubble', t), dst = D.getElementById('cart-icon-bubble');
      if (src && dst) dst.innerHTML = src.innerHTML;
    }).catch(function () {});
  };
  var giftCache = null;
  DWX.gifts = function () {
    if (giftCache) return giftCache;
    giftCache = _fetch('/products/gratisgeschenk.js', { cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (p) {
      var o = {};
      p.variants.forEach(function (v) { o[v.id] = { id: v.id, available: !!v.available, price: v.price, title: v.title, img: (v.featured_image && v.featured_image.src) || (p.featured_image || '') }; });
      return o;
    }).catch(function () { return {}; });
    return giftCache;
  };

  /* =====================================================================
     1) EFFEKTE
     ===================================================================== */
  function initFx() {
    D.documentElement.classList.add('dwx-js');
    var sp = D.createElement('div'); sp.className = 'dwx-sp'; D.body.appendChild(sp);
    var tick = false, hb = D.querySelector('.dwx-herobg');
    function onScroll() {
      if (tick) return; tick = true;
      requestAnimationFrame(function () {
        var h = D.documentElement.scrollHeight - W.innerHeight;
        sp.style.setProperty('--dwx-sp', h > 0 ? Math.min(1, W.scrollY / h) : 0);
        if (hb && !REDUCE && W.scrollY < 1400) hb.style.setProperty('--dwx-par', Math.round(W.scrollY * 0.16) + 'px');
        tick = false;
      });
    }
    W.addEventListener('scroll', onScroll, { passive: true }); onScroll();

    if (REDUCE || !('IntersectionObserver' in W)) return;
    var sel = '.dw-section-heading,.dw-category,.dw-product-card,.dw-guide__intro,.dw-guide__steps li,.dw-faq details,.dwx-gt__card,.dwx-bd__card,.dwx-cfgsec__grid>*,[data-dwx-reveal]';
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    var vh = W.innerHeight;
    $$(sel).forEach(function (el, i) {
      var r = el.getBoundingClientRect();
      if (r.top < vh * 0.92) return; /* schon sichtbar -> nicht verstecken */
      el.classList.add('dwx-reveal');
      el.style.setProperty('--dwx-d', ((i % 4) * 0.07) + 's');
      io.observe(el);
    });
  }

  function initTilt() {
    if (REDUCE || !FINE) return;
    $$('.dw-product-card,.dw-category,.dwx-gt__card,.dw-hero__product').forEach(function (el) {
      el.setAttribute('data-dwx-tilt', '');
      var raf = 0;
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect(), x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = 0;
          el.style.setProperty('--ry', ((x - 0.5) * 9).toFixed(2) + 'deg');
          el.style.setProperty('--rx', ((0.5 - y) * 7).toFixed(2) + 'deg');
          el.style.setProperty('--mx', (x * 100).toFixed(1) + '%');
          el.style.setProperty('--my', (y * 100).toFixed(1) + '%');
        });
      });
      el.addEventListener('pointerleave', function () {
        el.style.setProperty('--rx', '0deg'); el.style.setProperty('--ry', '0deg');
      });
    });
  }

  /* =====================================================================
     2) MENGEN-REGLER  (Toploader-Sets 1–10)
     ===================================================================== */
  var SHIP_FREE = 2999, G1 = 3000, G2 = 5000, G3 = 10000;


  /* =====================================================================
     2b) PACKUNGS-STAPEL: N echte Packungen, neue fallen von oben herein
     ===================================================================== */
  var STACK_LAYOUT = {"1":[[0.5,0.5,1.0]],"2":[[0.299,0.309,0.598],[0.701,0.691,0.598]],"3":[[0.5,0.32,0.563],[0.292,0.68,0.563],[0.708,0.68,0.563]],"4":[[0.292,0.32,0.563],[0.708,0.32,0.563],[0.292,0.68,0.563],[0.708,0.68,0.563]],"5":[[0.5,0.225,0.43],[0.341,0.5,0.43],[0.659,0.5,0.43],[0.341,0.775,0.43],[0.659,0.775,0.43]],"6":[[0.341,0.225,0.43],[0.659,0.225,0.43],[0.341,0.5,0.43],[0.659,0.5,0.43],[0.341,0.775,0.43],[0.659,0.775,0.43]],"7":[[0.354,0.247,0.395],[0.646,0.247,0.395],[0.208,0.5,0.395],[0.5,0.5,0.395],[0.792,0.5,0.395],[0.354,0.753,0.395],[0.646,0.753,0.395]],"8":[[0.354,0.247,0.395],[0.646,0.247,0.395],[0.208,0.5,0.395],[0.5,0.5,0.395],[0.792,0.5,0.395],[0.208,0.753,0.395],[0.5,0.753,0.395],[0.792,0.753,0.395]],"9":[[0.208,0.247,0.395],[0.5,0.247,0.395],[0.792,0.247,0.395],[0.208,0.5,0.395],[0.5,0.5,0.395],[0.792,0.5,0.395],[0.208,0.753,0.395],[0.5,0.753,0.395],[0.792,0.753,0.395]],"10":[[0.376,0.178,0.336],[0.624,0.178,0.336],[0.252,0.393,0.336],[0.5,0.393,0.336],[0.748,0.393,0.336],[0.252,0.607,0.336],[0.5,0.607,0.336],[0.748,0.607,0.336],[0.376,0.822,0.336],[0.624,0.822,0.336]]};
  var STACK_NEW = {"semi":{"ar":0.9092,"per":1,"L":{"1":[[0.5,0.5,0.98]],"2":[[0.3288,0.2916,0.6195],[0.6712,0.7084,0.6195]],"3":[[0.5,0.3265,0.5158],[0.2679,0.6735,0.5158],[0.7321,0.6735,0.5158]],"4":[[0.2679,0.3265,0.5158],[0.7321,0.3265,0.5158],[0.2679,0.6735,0.5158],[0.7321,0.6735,0.5158]],"5":[[0.5,0.2076,0.4346],[0.3044,0.5,0.4346],[0.6956,0.5,0.4346],[0.3044,0.7924,0.4346],[0.6956,0.7924,0.4346]],"6":[[0.3044,0.2076,0.4346],[0.6956,0.2076,0.4346],[0.3044,0.5,0.4346],[0.6956,0.5,0.4346],[0.3044,0.7924,0.4346],[0.6956,0.7924,0.4346]],"7":[[0.3425,0.2645,0.35],[0.6575,0.2645,0.35],[0.185,0.5,0.35],[0.5,0.5,0.35],[0.815,0.5,0.35],[0.3425,0.7355,0.35],[0.6575,0.7355,0.35]],"8":[[0.3425,0.2645,0.35],[0.6575,0.2645,0.35],[0.185,0.5,0.35],[0.5,0.5,0.35],[0.815,0.5,0.35],[0.185,0.7355,0.35],[0.5,0.7355,0.35],[0.815,0.7355,0.35]],"9":[[0.185,0.2645,0.35],[0.5,0.2645,0.35],[0.815,0.2645,0.35],[0.185,0.5,0.35],[0.5,0.5,0.35],[0.815,0.5,0.35],[0.185,0.7355,0.35],[0.5,0.7355,0.35],[0.815,0.7355,0.35]],"10":[[0.3494,0.1622,0.3348],[0.6506,0.1622,0.3348],[0.1987,0.3874,0.3348],[0.5,0.3874,0.3348],[0.8013,0.3874,0.3348],[0.1987,0.6126,0.3348],[0.5,0.6126,0.3348],[0.8013,0.6126,0.3348],[0.3494,0.8378,0.3348],[0.6506,0.8378,0.3348]]}},"sleeves":{"ar":1.202,"per":1,"L":{"1":[[0.5,0.5,0.8153]],"2":[[0.2765,0.3125,0.5033],[0.7235,0.6875,0.5033]],"3":[[0.5,0.3125,0.5033],[0.2987,0.6875,0.5033],[0.7013,0.6875,0.5033]],"4":[[0.2987,0.3125,0.5033],[0.7013,0.3125,0.5033],[0.2987,0.6875,0.5033],[0.7013,0.6875,0.5033]],"5":[[0.5,0.2287,0.364],[0.3544,0.5,0.364],[0.6456,0.5,0.364],[0.3544,0.7712,0.364],[0.6456,0.7712,0.364]],"6":[[0.3544,0.2287,0.364],[0.6456,0.2287,0.364],[0.3544,0.5,0.364],[0.6456,0.5,0.364],[0.3544,0.7712,0.364],[0.6456,0.7712,0.364]],"7":[[0.3544,0.2287,0.364],[0.6456,0.2287,0.364],[0.2088,0.5,0.364],[0.5,0.5,0.364],[0.7912,0.5,0.364],[0.3544,0.7712,0.364],[0.6456,0.7712,0.364]],"8":[[0.3544,0.2287,0.364],[0.6456,0.2287,0.364],[0.2088,0.5,0.364],[0.5,0.5,0.364],[0.7912,0.5,0.364],[0.2088,0.7712,0.364],[0.5,0.7712,0.364],[0.7912,0.7712,0.364]],"9":[[0.2088,0.2287,0.364],[0.5,0.2287,0.364],[0.7912,0.2287,0.364],[0.2088,0.5,0.364],[0.5,0.5,0.364],[0.7912,0.5,0.364],[0.2088,0.7712,0.364],[0.5,0.7712,0.364],[0.7912,0.7712,0.364]],"10":[[0.386,0.1813,0.2851],[0.614,0.1813,0.2851],[0.2719,0.3938,0.2851],[0.5,0.3938,0.2851],[0.7281,0.3938,0.2851],[0.2719,0.6062,0.2851],[0.5,0.6062,0.2851],[0.7281,0.6062,0.2851],[0.386,0.8187,0.2851],[0.614,0.8187,0.2851]],"11":[[0.2694,0.2852,0.2882],[0.5,0.2852,0.2882],[0.7306,0.2852,0.2882],[0.1541,0.5,0.2882],[0.3847,0.5,0.2882],[0.6153,0.5,0.2882],[0.8459,0.5,0.2882],[0.1541,0.7148,0.2882],[0.3847,0.7148,0.2882],[0.6153,0.7148,0.2882],[0.8459,0.7148,0.2882]],"12":[[0.1541,0.2852,0.2882],[0.3847,0.2852,0.2882],[0.6153,0.2852,0.2882],[0.8459,0.2852,0.2882],[0.1541,0.5,0.2882],[0.3847,0.5,0.2882],[0.6153,0.5,0.2882],[0.8459,0.5,0.2882],[0.1541,0.7148,0.2882],[0.3847,0.7148,0.2882],[0.6153,0.7148,0.2882],[0.8459,0.7148,0.2882]],"13":[[0.22,0.3261,0.2333],[0.4067,0.3261,0.2333],[0.5933,0.3261,0.2333],[0.78,0.3261,0.2333],[0.22,0.5,0.2333],[0.4067,0.5,0.2333],[0.5933,0.5,0.2333],[0.78,0.5,0.2333],[0.1267,0.6739,0.2333],[0.3133,0.6739,0.2333],[0.5,0.6739,0.2333],[0.6867,0.6739,0.2333],[0.8733,0.6739,0.2333]],"14":[[0.22,0.3261,0.2333],[0.4067,0.3261,0.2333],[0.5933,0.3261,0.2333],[0.78,0.3261,0.2333],[0.1267,0.5,0.2333],[0.3133,0.5,0.2333],[0.5,0.5,0.2333],[0.6867,0.5,0.2333],[0.8733,0.5,0.2333],[0.1267,0.6739,0.2333],[0.3133,0.6739,0.2333],[0.5,0.6739,0.2333],[0.6867,0.6739,0.2333],[0.8733,0.6739,0.2333]],"15":[[0.1267,0.3261,0.2333],[0.3133,0.3261,0.2333],[0.5,0.3261,0.2333],[0.6867,0.3261,0.2333],[0.8733,0.3261,0.2333],[0.1267,0.5,0.2333],[0.3133,0.5,0.2333],[0.5,0.5,0.2333],[0.6867,0.5,0.2333],[0.8733,0.5,0.2333],[0.1267,0.6739,0.2333],[0.3133,0.6739,0.2333],[0.5,0.6739,0.2333],[0.6867,0.6739,0.2333],[0.8733,0.6739,0.2333]],"16":[[0.1579,0.1813,0.2851],[0.386,0.1813,0.2851],[0.614,0.1813,0.2851],[0.8421,0.1813,0.2851],[0.1579,0.3938,0.2851],[0.386,0.3938,0.2851],[0.614,0.3938,0.2851],[0.8421,0.3938,0.2851],[0.1579,0.6062,0.2851],[0.386,0.6062,0.2851],[0.614,0.6062,0.2851],[0.8421,0.6062,0.2851],[0.1579,0.8187,0.2851],[0.386,0.8187,0.2851],[0.614,0.8187,0.2851],[0.8421,0.8187,0.2851]],"17":[[0.22,0.2392,0.2333],[0.4067,0.2392,0.2333],[0.5933,0.2392,0.2333],[0.78,0.2392,0.2333],[0.22,0.4131,0.2333],[0.4067,0.4131,0.2333],[0.5933,0.4131,0.2333],[0.78,0.4131,0.2333],[0.22,0.5869,0.2333],[0.4067,0.5869,0.2333],[0.5933,0.5869,0.2333],[0.78,0.5869,0.2333],[0.1267,0.7608,0.2333],[0.3133,0.7608,0.2333],[0.5,0.7608,0.2333],[0.6867,0.7608,0.2333],[0.8733,0.7608,0.2333]],"18":[[0.22,0.2392,0.2333],[0.4067,0.2392,0.2333],[0.5933,0.2392,0.2333],[0.78,0.2392,0.2333],[0.22,0.4131,0.2333],[0.4067,0.4131,0.2333],[0.5933,0.4131,0.2333],[0.78,0.4131,0.2333],[0.1267,0.5869,0.2333],[0.3133,0.5869,0.2333],[0.5,0.5869,0.2333],[0.6867,0.5869,0.2333],[0.8733,0.5869,0.2333],[0.1267,0.7608,0.2333],[0.3133,0.7608,0.2333],[0.5,0.7608,0.2333],[0.6867,0.7608,0.2333],[0.8733,0.7608,0.2333]],"19":[[0.22,0.2392,0.2333],[0.4067,0.2392,0.2333],[0.5933,0.2392,0.2333],[0.78,0.2392,0.2333],[0.1267,0.4131,0.2333],[0.3133,0.4131,0.2333],[0.5,0.4131,0.2333],[0.6867,0.4131,0.2333],[0.8733,0.4131,0.2333],[0.1267,0.5869,0.2333],[0.3133,0.5869,0.2333],[0.5,0.5869,0.2333],[0.6867,0.5869,0.2333],[0.8733,0.5869,0.2333],[0.1267,0.7608,0.2333],[0.3133,0.7608,0.2333],[0.5,0.7608,0.2333],[0.6867,0.7608,0.2333],[0.8733,0.7608,0.2333]],"20":[[0.1267,0.2392,0.2333],[0.3133,0.2392,0.2333],[0.5,0.2392,0.2333],[0.6867,0.2392,0.2333],[0.8733,0.2392,0.2333],[0.1267,0.4131,0.2333],[0.3133,0.4131,0.2333],[0.5,0.4131,0.2333],[0.6867,0.4131,0.2333],[0.8733,0.4131,0.2333],[0.1267,0.5869,0.2333],[0.3133,0.5869,0.2333],[0.5,0.5869,0.2333],[0.6867,0.5869,0.2333],[0.8733,0.5869,0.2333],[0.1267,0.7608,0.2333],[0.3133,0.7608,0.2333],[0.5,0.7608,0.2333],[0.6867,0.7608,0.2333],[0.8733,0.7608,0.2333]]}},"black":{"ar":1.2869,"per":1,"L":{"1":[[0.5,0.5,0.7615]],"2":[[0.2615,0.3125,0.4701],[0.7385,0.6875,0.4701]],"3":[[0.5,0.3125,0.4701],[0.312,0.6875,0.4701],[0.688,0.6875,0.4701]],"4":[[0.312,0.3125,0.4701],[0.688,0.3125,0.4701],[0.312,0.6875,0.4701],[0.688,0.6875,0.4701]],"5":[[0.5,0.2287,0.34],[0.364,0.5,0.34],[0.636,0.5,0.34],[0.364,0.7712,0.34],[0.636,0.7712,0.34]],"6":[[0.364,0.2287,0.34],[0.636,0.2287,0.34],[0.364,0.5,0.34],[0.636,0.5,0.34],[0.364,0.7712,0.34],[0.636,0.7712,0.34]],"7":[[0.364,0.2287,0.34],[0.636,0.2287,0.34],[0.228,0.5,0.34],[0.5,0.5,0.34],[0.772,0.5,0.34],[0.364,0.7712,0.34],[0.636,0.7712,0.34]],"8":[[0.364,0.2287,0.34],[0.636,0.2287,0.34],[0.228,0.5,0.34],[0.5,0.5,0.34],[0.772,0.5,0.34],[0.228,0.7712,0.34],[0.5,0.7712,0.34],[0.772,0.7712,0.34]],"9":[[0.228,0.2287,0.34],[0.5,0.2287,0.34],[0.772,0.2287,0.34],[0.228,0.5,0.34],[0.5,0.5,0.34],[0.772,0.5,0.34],[0.228,0.7712,0.34],[0.5,0.7712,0.34],[0.772,0.7712,0.34]],"10":[[0.3935,0.1813,0.2663],[0.6065,0.1813,0.2663],[0.287,0.3938,0.2663],[0.5,0.3938,0.2663],[0.713,0.3938,0.2663],[0.287,0.6062,0.2663],[0.5,0.6062,0.2663],[0.713,0.6062,0.2663],[0.3935,0.8187,0.2663],[0.6065,0.8187,0.2663]]}}};
  STACK_LAYOUT[20] = [[0.204,0.485,0.2],[0.352,0.485,0.2],[0.5,0.485,0.2],[0.648,0.485,0.2],[0.796,0.485,0.2],[0.204,0.613,0.2],[0.352,0.613,0.2],[0.5,0.613,0.2],[0.648,0.613,0.2],[0.796,0.613,0.2],[0.204,0.741,0.2],[0.352,0.741,0.2],[0.5,0.741,0.2],[0.648,0.741,0.2],[0.796,0.741,0.2],[0.204,0.869,0.2],[0.352,0.869,0.2],[0.5,0.869,0.2],[0.648,0.869,0.2],[0.796,0.869,0.2]];
  var STACK_LAYOUTS = { toploader: { ar: 1, per: 1, L: STACK_LAYOUT, bg: { n: 20, cx: 0.5, cy: 0.235, w: 0.66, ar: 0.565 } }, semi: STACK_NEW.semi, sleeves: STACK_NEW.sleeves, black: STACK_NEW.black };
  function Stack(host, src, kind) {
    var KS = STACK_LAYOUTS[kind] || STACK_LAYOUTS.toploader, LAY = KS.L, AR = KS.ar || 1, packs = [], self = this, bgEl = null;
    host.classList.add('dwx-stack');
    var pre = new Image(); pre.src = src;
    function place(el, l, i) {
      el.style.left = (l[0] * 100) + '%'; el.style.top = (l[1] * 100) + '%';
      el.style.width = (l[2] * 100) + '%'; el.style.zIndex = i + 1;
    }
    function make() {
      var d = D.createElement('div'); d.className = 'dwx-pk'; d.style.aspectRatio = '1 / ' + AR;
      var im = new Image(); im.alt = ''; im.decoding = 'async'; im.draggable = false; im.src = src;
      d.appendChild(im); host.appendChild(d); return d;
    }
    function impact(l, z) {
      if (REDUCE || !host.animate) return;
      var x = l[0] * 100, y = (l[1] + l[2] * AR * 0.28) * 100, w = l[2] * 100 * 0.95;
      var ring = D.createElement('i'); ring.className = 'dwx-impact';
      ring.style.cssText = 'left:' + x + '%;top:' + y + '%;width:' + w + '%;z-index:' + (z + 1);
      host.appendChild(ring);
      var a = ring.animate([{ transform: 'translate(-50%,-50%) scale(.25)', opacity: .95 }, { transform: 'translate(-50%,-50%) scale(1.2)', opacity: 0 }], { duration: 560, easing: 'cubic-bezier(.2,.7,.3,1)' });
      a.onfinish = function () { ring.remove(); };
      for (var k = 0; k < 7; k++) {
        var sp = D.createElement('i'); sp.className = 'dwx-spark';
        sp.style.cssText = 'left:' + x + '%;top:' + y + '%;z-index:' + (z + 2);
        host.appendChild(sp);
        var ang = (-Math.PI * (0.15 + 0.7 * Math.random())), dist = 18 + Math.random() * 34;
        (function (s, an, di) {
          var b = s.animate([{ transform: 'translate(0,0) scale(1)', opacity: 1 }, { transform: 'translate(' + (Math.cos(an) * di) + 'px,' + (Math.sin(an) * di) + 'px) scale(.2)', opacity: 0 }], { duration: 520 + Math.random() * 200, easing: 'ease-out' });
          b.onfinish = function () { s.remove(); };
        })(sp, ang, dist);
      }
      host.animate([{ transform: 'translateY(0)' }, { transform: 'translateY(2px)' }, { transform: 'translateY(0)' }], { duration: 150 });
    }
    function drop(el, l, i, k) {
      var im = el.firstChild; if (REDUCE || !im.animate) return;
      var dur = 950, delay = k * 120, rot = (k % 2 ? 1 : -1) * (5 + Math.random() * 4);
      im.animate([
        { transform: 'translateY(-150%) rotate(' + rot + 'deg)', opacity: 0, offset: 0, easing: 'cubic-bezier(.5,0,.9,.55)' },
        { opacity: 1, offset: .14 },
        { transform: 'translateY(0) rotate(0deg) scale(1,1)', offset: .6, easing: 'cubic-bezier(.2,.7,.3,1)' },
        { transform: 'translateY(-4%) scale(.99,1.01)', offset: .76, easing: 'ease-in' },
        { transform: 'translateY(0) scale(1.02,.97)', offset: .88, easing: 'ease-out' },
        { transform: 'none', opacity: 1, offset: 1 }
      ], { duration: dur, delay: delay, easing: 'linear', fill: 'both' });
      setTimeout(function () { impact(l, i); }, delay + dur * 0.6);
    }
    function leave(el) {
      var im = el.firstChild;
      if (REDUCE || !im.animate) { el.remove(); return; }
      el.style.zIndex = 999;
      var a = im.animate([{ transform: 'none', opacity: 1 }, { transform: 'translateY(-110%) rotate(7deg)', opacity: 0 }], { duration: 380, easing: 'cubic-bezier(.4,0,.8,.4)', fill: 'forwards' });
      a.onfinish = function () { el.remove(); };
    }
    function bgShow(on, animate) {
      var src = W.DWX_ART && W.DWX_ART.carton, B = KS.bg;
      if (!B || !src) return;
      if (on && !bgEl) {
        bgEl = D.createElement('div'); bgEl.className = 'dwx-pk dwx-pkbg';
        bgEl.style.cssText = 'left:' + (B.cx * 100) + '%;top:' + (B.cy * 100) + '%;width:' + (B.w * 100) + '%;aspect-ratio:1 / ' + B.ar + ';z-index:0';
        var im = new Image(); im.alt = ''; im.decoding = 'async'; im.draggable = false; im.src = src; bgEl.appendChild(im); host.insertBefore(bgEl, host.firstChild);
        if (animate && !REDUCE && im.animate) im.animate([{ transform: 'translateY(-60%) scale(.9)', opacity: 0 }, { transform: 'translateY(4%) scale(1.02)', opacity: 1, offset: .65 }, { transform: 'none', opacity: 1 }], { duration: 800, easing: 'cubic-bezier(.2,.8,.3,1)', fill: 'both' });
      } else if (!on && bgEl) {
        var old = bgEl; bgEl = null;
        if (REDUCE || !old.firstChild.animate) old.remove(); else { var a = old.firstChild.animate([{ opacity: 1, transform: 'none' }, { opacity: 0, transform: 'translateY(-30%) scale(.92)' }], { duration: 360, fill: 'forwards' }); a.onfinish = function () { old.remove(); }; }
      }
    }
    self.set = function (target, animate) {
      target = Math.max(1, target | 0);
      var lay = LAY[target]; if (!lay) return;
      bgShow(!!(KS.bg && target === KS.bg.n), animate);
      while (packs.length > target) { leave(packs.pop()); }
      for (var i = 0; i < packs.length; i++) place(packs[i], lay[i], i);
      var k = 0;
      for (var j = packs.length; j < target; j++) {
        var el = make(); place(el, lay[j], j); packs.push(el);
        if (animate) drop(el, lay[j], j, k++);
      }
    };
    self.playIn = function () {
      var lay = LAY[packs.length]; if (!lay) return;
      if (bgEl && bgEl.firstChild.animate && !REDUCE) bgEl.firstChild.animate([{ transform: 'translateY(-60%) scale(.9)', opacity: 0 }, { transform: 'none', opacity: 1 }], { duration: 800, easing: 'cubic-bezier(.2,.8,.3,1)', fill: 'both' });
      packs.forEach(function (el, i) { drop(el, lay[i], i, i); });
    };
  }


  /* =====================================================================
     2c) FLAMMEN am Regler: je höher die Stufe, desto stärker. Beim Loslassen leuchtet der Kauf-Button auf.
     ===================================================================== */
  function makeSprite(r, g, b) {
    var c = D.createElement('canvas'); c.width = c.height = 64;
    var x = c.getContext('2d'), gr = x.createRadialGradient(32, 32, 0, 32, 32, 32);
    gr.addColorStop(0, 'rgba(' + r + ',' + g + ',' + b + ',0.75)');
    gr.addColorStop(0.4, 'rgba(' + r + ',' + g + ',' + b + ',0.38)');
    gr.addColorStop(1, 'rgba(' + r + ',' + g + ',' + b + ',0)');
    x.fillStyle = gr; x.fillRect(0, 0, 64, 64); return c;
  }
  var SPR = null;
  function Fire(host, rangeEl) {
    if (REDUCE || !D.createElement('canvas').getContext) return { setLevel: function () {}, burst: function () {} };
    if (!SPR) SPR = [makeSprite(255, 205, 110), makeSprite(255, 120, 35), makeSprite(190, 35, 20)];
    var cv = D.createElement('canvas'); cv.className = 'dwx-fire'; cv.setAttribute('aria-hidden', 'true'); host.appendChild(cv);
    var cx = cv.getContext('2d'), parts = [], level = 0, target = 0, run = false, last = 0, vis = true, w = 0, h = 0, acc = 0, t0 = 0;
    function size() {
      var r = host.getBoundingClientRect(), dpr = Math.min(2, W.devicePixelRatio || 1);
      w = Math.max(1, Math.round(r.width)); h = Math.round(Math.max(110, Math.min(r.width < 500 ? 150 : 300, r.width * 0.62)));
      cv.width = w * dpr; cv.height = h * dpr; cv.style.width = w + 'px'; cv.style.height = h + 'px'; cx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }
    function thumbX() {
      var hr = host.getBoundingClientRect(), rr = rangeEl.getBoundingClientRect();
      var f = (+rangeEl.max) ? (+rangeEl.value) / (+rangeEl.max) : 0;
      return rr.left - hr.left + 17 + (rr.width - 34) * f;
    }
    function spawn(n, L, x0, burst) {
      for (var i = 0; i < n && parts.length < 320; i++) {
        var spark = Math.random() < 0.18 + 0.2 * L;
        var life = spark ? 0.5 + Math.random() * 0.6 : 0.55 + Math.random() * 0.55 + 0.45 * L;
        parts.push({
          x: x0 + (Math.random() - 0.5) * (6 + 16 * L), y: h - 10 + Math.random() * 6,
          vx: (Math.random() - 0.5) * (22 + 60 * L) * (burst ? 2.2 : 1),
          vy: -(spark ? 90 + Math.random() * 140 : 40 + Math.random() * 70) * (0.7 + 0.9 * L) * (burst ? 1.6 : 1),
          life: life, max: life, size: spark ? 3 + 3 * L : (6 + 15 * L) * (0.7 + Math.random() * 0.6), spark: spark, seed: Math.random() * 6.28
        });
      }
    }
    function frame(ts) {
      if (!run) return;
      var dt = Math.min(0.05, (ts - last) / 1000 || 0.016); last = ts;
      level += (target - level) * Math.min(1, dt * 6);
      var L = level, x0 = thumbX();
      acc += (L > 0.02 ? 8 + 190 * Math.pow(L, 1.5) : 0) * dt;
      var n = Math.floor(acc); acc -= n; spawn(n, L, x0, false);
      if (L > 0.25 && Math.random() < dt * 20 * L) { var tx = Math.random() * x0; spawn(1, L * 0.6, tx, false); }
      cx.clearRect(0, 0, w, h); cx.globalCompositeOperation = 'lighter';
      if (L > 0.05) {
        var g = cx.createRadialGradient(x0, h - 8, 0, x0, h - 8, 30 + 70 * L);
        g.addColorStop(0, 'rgba(255,110,40,' + (0.1 + 0.22 * L) + ')'); g.addColorStop(1, 'rgba(255,60,20,0)');
        cx.fillStyle = g; cx.fillRect(Math.max(0, x0 - 140), 0, 280, h);
      }
      for (var i = parts.length - 1; i >= 0; i--) {
        var p = parts[i]; p.life -= dt;
        if (p.life <= 0 || p.y < -20) { parts.splice(i, 1); continue; }
        var k = 1 - p.life / p.max;
        p.x += (p.vx + Math.sin(ts / 140 + p.seed) * (10 + 18 * L)) * dt; p.y += p.vy * dt;
        var s = p.spark ? p.size * (1 - k * 0.6) : p.size * (1 + k * 0.4) * (1 - k * k * 0.55);
        var spr = k < 0.28 ? SPR[0] : (k < 0.65 ? SPR[1] : SPR[2]);
        cx.globalAlpha = Math.max(0, (p.spark ? 1 : 0.6) * (1 - k * k));
        cx.drawImage(spr, p.x - s, p.y - s * 1.6, s * 2, s * 3.2);
      }
      cx.globalAlpha = 1;
      if (L < 0.02 && !parts.length) { run = false; return; }
      requestAnimationFrame(frame);
    }
    function start() { if (run || !vis || D.hidden) return; run = true; last = performance.now(); size(); requestAnimationFrame(frame); }
    if ('IntersectionObserver' in W) {
      new IntersectionObserver(function (es) { vis = es[0].isIntersecting; if (vis && (target > 0.02 || parts.length)) start(); else if (!vis) run = false; }, { threshold: 0.05 }).observe(host);
    }
    W.addEventListener('resize', function () { if (run) size(); });
    return {
      setLevel: function (l) { target = Math.max(0, Math.min(1, l)); if (target > 0.02) start(); },
      burst: function () { size(); var L = Math.max(0.35, level); spawn(Math.round(26 + 40 * L), L, thumbX(), true); start(); }
    };
  }


  /* =====================================================================
     2d) POP-EFFEKTE: aus dem Icon springt ein Bild heraus und glänzt (Versand, Sleeves, Pokémon, Toploader-Set)
     ===================================================================== */
  function popAt(container, key, anchor) {
    var art = W.DWX_ART && W.DWX_ART.pop, src = art && art[key];
    if (REDUCE || !src || !container || !container.animate) return;
    var cr = container.getBoundingClientRect(), ar = (anchor || container).getBoundingClientRect();
    var x = ar.left - cr.left + ar.width / 2, y = ar.top - cr.top + ar.height / 2;
    var el = D.createElement('span'); el.className = 'dwx-pop'; el.style.left = x + 'px'; el.style.top = y + 'px';
    el.style.setProperty('--m', 'url("' + src + '")');
    el.innerHTML = '<img alt="" src="' + src + '"><i class="dwx-pop__shine"></i>';
    container.appendChild(el);
    var up = -52;
    var a = el.animate([
      { transform: 'translate(-50%,-50%) scale(.2)', opacity: 0, offset: 0 },
      { transform: 'translate(-50%,-50%) translateY(' + up + 'px) scale(1.4) rotate(-7deg)', opacity: 1, offset: .26, easing: 'cubic-bezier(.2,.9,.3,1.25)' },
      { transform: 'translate(-50%,-50%) translateY(' + (up + 8) + 'px) scale(1.22) rotate(4deg)', opacity: 1, offset: .5 },
      { transform: 'translate(-50%,-50%) translateY(' + (up + 2) + 'px) scale(1.3) rotate(0deg)', opacity: 1, offset: .78 },
      { transform: 'translate(-50%,-50%) translateY(-4px) scale(.25)', opacity: 0, offset: 1 }
    ], { duration: 2000, easing: 'ease-in-out' });
    el.classList.add('is-on');
    a.onfinish = function () { el.remove(); };
    sparksAt(container, x, y);
  }

  function sparksAt(container, x, y) {
    if (REDUCE || !container) return;
    for (var i = 0; i < 8; i++) {
      var sp = D.createElement('i'); sp.className = 'dwx-spark'; sp.style.left = x + 'px'; sp.style.top = y + 'px'; sp.style.zIndex = 29; container.appendChild(sp);
      var ang = Math.random() * Math.PI * 2, dist = 22 + Math.random() * 30;
      (function (s, an, di) {
        if (!s.animate) { s.remove(); return; }
        var b = s.animate([{ transform: 'translate(0,0) scale(1)', opacity: 1 }, { transform: 'translate(' + Math.cos(an) * di + 'px,' + (Math.sin(an) * di - 24) + 'px) scale(.2)', opacity: 0 }], { duration: 650 + Math.random() * 300, delay: 100, easing: 'ease-out', fill: 'both' });
        b.onfinish = function () { s.remove(); };
        setTimeout(function () { s.remove(); }, 2500);
      })(sp, ang, dist);
    }
  }

  /* Kauf-Button leuchtet kurz auf (Regler losgelassen) */
  function pingEls(list) {
    list.forEach(function (el) {
      if (!el) return; el.classList.remove('is-ping'); void el.offsetWidth; el.classList.add('is-ping');
      setTimeout(function () { el.classList.remove('is-ping'); }, 1200);
    });
  }

  /* Produktarten: Variantentitel -> Anzahl, Schritte, Texte */
  function seq(a, b) { var r = []; for (var i = a; i <= b; i++) r.push(i); return r; }
  var KINDS = {
    toploader: { rx: /^\s*(\d+)\s*Sets?\b/i, div: 1, steps: seq(1, 10).concat([20]), unit: ['Set', 'Sets'], per: 'Set', stackPer: 1,
      pieces: function (n) { return '<b>' + n * 100 + '</b> Toploader<br>+ <b>' + n * 100 + '</b> Sleeves'; },
      label: function (n) { return n === 20 ? '20 Sets (Karton)' : n + (n === 1 ? ' Set' : ' Sets'); } },
    sleeves: { rx: /^\s*(\d+)\s*Sleeves/i, div: 100, steps: seq(1, 20), unit: ['Pack', 'Packs'], per: 'Pack', stackPer: 1,
      pieces: function (n) { return '<b>' + n * 100 + '</b> klare Sleeves<br>(' + n + ' × 100 Stück)'; },
      label: function (n) { return (n * 100) + ' Sleeves'; } },
    semi: { rx: /^\s*(\d+)\s*Sets?\b/i, div: 1, steps: seq(1, 10), unit: ['Set', 'Sets'], per: 'Set', stackPer: 1,
      pieces: function (n) { return '<b>' + n * 50 + '</b> Semi-Rigid-Hüllen<br>+ <b>' + n * 50 + '</b> Sleeves'; },
      label: function (n) { return n + (n === 1 ? ' Set' : ' Sets'); } },
    black: { rx: /^\s*(\d+)\s*Stück/i, div: 100, steps: [1, 2, 4, 6, 8, 10], unit: ['Pack', 'Packs'], per: 'Pack', stackPer: 1,
      pieces: function (n) { return '<b>' + n * 100 + '</b> schwarze Sleeves<br>(' + n + ' × 100 Stück)'; },
      label: function (n) { return (n * 100) + ' Stück'; } }
  };

  function initCfg(root) {
    if (root.__dwx) return; root.__dwx = 1;
    var ctx = root.getAttribute('data-context') || 'product';
    var kind = root.getAttribute('data-kind') || 'toploader';
    var K = KINDS[kind] || KINDS.toploader, steps = K.steps, MAXI = steps.length - 1;
    var jd = $('script[data-dwx-cfg-json]', root); if (!jd) return;
    var data; try { data = JSON.parse(jd.textContent); } catch (e) { return; }
    var map = {};
    data.variants.forEach(function (v) { var m = K.rx.exec(v.title); if (m) map[(+m[1]) / K.div] = v; });
    if (!map[steps[0]]) return;
    var single = map[steps[0]].price / steps[0], N = steps[0];
    var q = function (s) { return $(s, root); };
    var range = q('[data-r]'), nEl = q('[data-n]'), unitEl = q('[data-unit]'), piecesEl = q('.dwx-cfg__pieces');
    var nowEl = q('[data-now]'), refEl = q('[data-ref]'), saveEl = q('[data-save]'), perEl = q('[data-per]');
    var hintEl = q('[data-hint]'), shipEl = q('[data-ship]'), ticksEl = q('[data-ticks]');
    var minus = q('[data-minus]'), plus = q('[data-plus]'), cta = q('[data-cta]');
    var perks = { ship: q('[data-perk="ship"]'), black: q('[data-perk="black"]'), poke: q('[data-perk="poke"]'), tl: q('[data-perk="tl"]') };
    var gifts = {};
    function idxOf(n) { var best = 0, bd = 1e9; for (var j = 0; j < steps.length; j++) { var d = Math.abs(steps[j] - n); if (d < bd) { bd = d; best = j; } } return best; }
    range.min = 0; range.max = MAXI; range.step = 1;
    range.setAttribute('aria-label', 'Anzahl der ' + K.unit[1] + ' (' + steps[0] + ' bis ' + steps[MAXI] + ')');
    if (steps.length > 10) root.classList.add('dwx-cfg--dense');
    if (ctx === 'product') D.documentElement.classList.add('dwx-has-cfg');

    /* Packungs-Stapel (Bild kommt aus data-pack, nur wenn die Datei im Shop liegt) */
    var stage = null, packSrc = root.getAttribute('data-pack'), stageHost = null, lazyStage = false;
    if (packSrc) {
      if (ctx === 'home') {
        var sec = root.closest('.dwx-cfgsec__grid') || root.closest('.dwx-cfgsec'), med = sec && $('.dwx-cfgsec__media', sec);
        if (W.matchMedia && W.matchMedia('(max-width: 749px)').matches && q('[data-stage]')) {
          /* Handy: Packungen direkt in der Regler-Karte (neben der Zahl), kein großes Bild davor */
          stageHost = q('[data-stage]'); var topEl = q('.dwx-cfg__top'); if (topEl) topEl.classList.add('has-stage'); if (sec) sec.classList.add('has-mstage');
        } else if (med) { med.classList.add('has-stack'); stageHost = D.createElement('div'); stageHost.className = 'dwx-stackhost'; med.appendChild(stageHost); }
      } else { stageHost = q('[data-stage]'); }
      if (stageHost) { if (ctx === 'home' && sec && sec.hidden) lazyStage = true; else stage = new Stack(stageHost, packSrc, kind); }
    }

    /* Skala */
    var th = '';
    for (var i = 0; i < steps.length; i++) {
      var n = steps[i], v = map[n], pct = 0;
      if (v && i > 0) { pct = Math.floor((single * n - v.price) / (single * n) * 100); }
      var key = (n === steps[0] || n === steps[MAXI] || n % 5 === 0);
      th += '<button type="button" class="dwx-cfg__tick' + (v && v.available ? '' : ' is-off') + (key ? ' is-key' : '') + '" data-n="' + n + '" style="--i:' + i + '" aria-label="' + K.label(n) + '"><b>' + n + '</b>' + (i > 0 && pct > 0 ? '<span>&minus;' + pct + '&nbsp;%</span>' : '<span>&nbsp;</span>') + '</button>';
    }
    ticksEl.innerHTML = th; ticksEl.style.setProperty('--max', MAXI);

    var fireHost = q('.dwx-cfg__stepwrap'), fire = fireHost ? new Fire(fireHost, range) : null;
    function heat() { var l = MAXI ? idxOf(N) / MAXI : 0; root.style.setProperty('--heat', l.toFixed(3)); if (fire) fire.setLevel(l); }
    /* Fester Kauf-Balken (nur Produktseite): immer ein Kauf-Button im Bild */
    var sticky = null, stickyTxt = null;
    if (ctx === 'product' && cta && 'IntersectionObserver' in W) {
      sticky = D.createElement('div'); sticky.className = 'dwx-sticky'; sticky.setAttribute('role', 'region'); sticky.setAttribute('aria-label', 'Schnellkauf');
      sticky.innerHTML = '<div class="dwx-sticky__txt"><b></b><span></span></div><button type="button" class="button button--primary">In den Warenkorb</button>';
      D.body.appendChild(sticky); stickyTxt = $('.dwx-sticky__txt', sticky);
      $('button', sticky).addEventListener('click', function () { if (!cta.disabled) cta.click(); });
      var sio2 = new IntersectionObserver(function (es) {
        var on = !es[0].isIntersecting;
        sticky.classList.toggle('is-on', on); D.body.classList.toggle('dwx-sticky-on', on);
      }, { threshold: 0.6 });
      sio2.observe(cta);
    }
    function paintSticky(v, price, ok) {
      if (!sticky) return;
      $('b', stickyTxt).textContent = K.label(N) + (v ? ' · ' + eur(price) : '');
      $('span', stickyTxt).textContent = ok ? 'bereit für den Warenkorb' : 'aktuell nicht lieferbar';
      var b = $('button', sticky); b.disabled = !ok;
    }

    var popReady = false; setTimeout(function () { popReady = true; }, 900);
    function perkSlot(li) { return li && $('.dwx-perk__slot', li); }
    function perkIn(li, key, animate) {
      var art = W.DWX_ART && W.DWX_ART.pop, src = art && art[key], slot = perkSlot(li);
      if (!src || !slot) return;
      var el = li.__pimg;
      if (el) { if (animate) perkBounce(li); return; }
      el = D.createElement('span'); el.className = 'dwx-perkimg'; el.style.setProperty('--m', 'url("' + src + '")');
      el.innerHTML = '<span class="dwx-perkimg__in"><img alt="" decoding="async" src="' + src + '"><i class="dwx-pop__shine"></i></span>';
      slot.appendChild(el); li.__pimg = el; li.classList.add('has-img');
      if (animate && !REDUCE && el.animate) {
        el.animate([
          { transform: 'translate(-50%,-50%) scale(.15)', opacity: 0 },
          { transform: 'translate(-50%,-78%) scale(1.45) rotate(-9deg)', opacity: 1, offset: .38 },
          { transform: 'translate(-50%,-44%) scale(.92) rotate(4deg)', opacity: 1, offset: .66 },
          { transform: 'translate(-50%,-50%) scale(1)', opacity: 1 }
        ], { duration: 1000, easing: 'cubic-bezier(.2,.8,.3,1)' });
        sparksAt(slot, slot.clientWidth / 2, slot.clientHeight / 2);
      }
    }
    function perkBounce(li) {
      var el = li && li.__pimg; if (!el || REDUCE || !el.animate) return;
      el.animate([
        { transform: 'translate(-50%,-50%) scale(1)' },
        { transform: 'translate(-50%,-72%) scale(1.38) rotate(-7deg)', offset: .36 },
        { transform: 'translate(-50%,-46%) scale(.94) rotate(3deg)', offset: .68 },
        { transform: 'translate(-50%,-50%) scale(1)' }
      ], { duration: 850, easing: 'cubic-bezier(.2,.8,.3,1)' });
      var slot = perkSlot(li); if (slot) sparksAt(slot, slot.clientWidth / 2, slot.clientHeight / 2);
    }
    function perkOut(li) {
      var el = li && li.__pimg; if (!el) return;
      li.__pimg = null; li.classList.remove('has-img');
      if (REDUCE || !el.animate) { el.remove(); return; }
      var an = el.animate([{ transform: 'translate(-50%,-50%) scale(1)', opacity: 1 }, { transform: 'translate(-50%,-50%) scale(.15)', opacity: 0 }], { duration: 260, easing: 'ease-in', fill: 'forwards' });
      an.onfinish = function () { el.remove(); };
      setTimeout(function () { el.remove(); }, 700);
    }
    function popAllOn() { ['ship', 'black', 'poke', 'tl'].forEach(function (k, i) { var li = perks[k]; if (li && li.classList.contains('is-on')) setTimeout(function () { perkBounce(li); }, 450 + i * 260); }); }
    function setPerk(el, on, text, key) {
      if (!el) return;
      var was = el.classList.contains('is-on');
      el.classList.toggle('is-on', !!on);
      if (on && !was) {
        perkIn(el, key, popReady);
        if (popReady) { el.classList.remove('is-pop'); void el.offsetWidth; el.classList.add('is-pop'); }
      } else if (!on && was) perkOut(el);
      else if (on && !el.__pimg) perkIn(el, key, false);
      var s = $('[data-st]', el); if (s) s.textContent = text;
    }

    function paint() {
      var v = map[N], price = v ? v.price : 0, ok = !!(v && v.available), ix = idxOf(N);
      range.value = ix;
      range.style.setProperty('--p', (MAXI ? ix / MAXI * 100 : 0).toFixed(1) + '%');
      nEl.textContent = N; unitEl.textContent = N === 1 ? K.unit[0] : K.unit[1];
      if (piecesEl) piecesEl.innerHTML = K.pieces(N);
      $$('.dwx-cfg__tick', root).forEach(function (t) { t.classList.toggle('is-on', +t.getAttribute('data-n') === N); });
      minus.disabled = ix <= 0; plus.disabled = ix >= MAXI;
      root.setAttribute('data-state', ok ? 'on' : 'off');
      paintSticky(v, price, ok);
      heat();
      range.setAttribute('aria-valuetext', N + ' ' + (N === 1 ? K.unit[0] : K.unit[1]) + (v ? ' für ' + eur(price) : ''));
      if (!v) { if (cta) { cta.textContent = 'Nicht lieferbar'; cta.classList.add('is-off'); }
      nowEl.textContent = '–'; refEl.textContent = ''; saveEl.style.display = 'none'; perEl.textContent = 'Diese Größe ist gerade nicht verfügbar.'; return; }
      nowEl.textContent = eur(price);
      if (cta && !cta.disabled) { cta.textContent = ok ? 'In den Warenkorb legen · ' + eur(price) : 'Nicht lieferbar'; cta.classList.toggle('is-off', !ok); }
      var ref = Math.round(single * N), save = ref - price, pc = Math.floor(save / ref * 100);
      refEl.textContent = N > steps[0] ? 'statt ' + N + ' × ' + eur(Math.round(single)) + ' = ' + eur(ref) : '';
      if (save > 0) { saveEl.style.display = ''; saveEl.textContent = 'Du sparst ' + eur(save) + ' (' + pc + ' %)'; } else { saveEl.style.display = 'none'; }
      perEl.textContent = ok ? eur(Math.round(price / N)) + ' pro ' + K.per : 'Aktuell nicht lieferbar – wähle eine andere Größe.';
      if (shipEl) shipEl.textContent = price >= SHIP_FREE ? 'Versand: gratis' : 'Versand: 3,50 € · ab 29,99 € gratis';
      var pokeOk = gifts.poke ? gifts.poke.available : true;
      setPerk(perks.ship, price >= SHIP_FREE, price >= SHIP_FREE ? 'dabei' : 'ab 29,99 €', 'ship');
      setPerk(perks.black, price >= G1, price >= G1 ? 'dabei' : 'ab 30 €', 'black');
      setPerk(perks.poke, price >= G2 && pokeOk, !pokeOk ? 'gerade vergriffen' : (price >= G2 ? 'dabei' : 'ab 50 €'), 'poke');
      setPerk(perks.tl, price >= G3, price >= G3 ? 'dabei' : 'ab 100 €', 'tl');
      var next = null;
      if (price < G1) next = ['schwarze Sleeves', G1 - price];
      else if (price < G2 && pokeOk) next = ['50 Pokémon-Karten', G2 - price];
      else if (price < G3) next = ['1 Toploader-Set', G3 - price];
      hintEl.innerHTML = next ? 'Noch <b>' + eur(next[1]) + '</b> bis zum Gratis-Geschenk: <b>' + next[0] + '</b>.' : 'Alle verfügbaren Geschenke sind in dieser Bestellung dabei.';
    }

    function set(n, user) {
      var wasN = N, before = {};
      for (var pk in perks) before[pk] = !!(perks[pk] && perks[pk].classList.contains('is-on'));
      N = steps[idxOf(n)]; paint();
      if (popReady && N !== wasN && idxOf(N) === MAXI) {
        var di = 0; for (var bk in before) { if (before[bk] && perks[bk]) { (function (l, d) { setTimeout(function () { perkBounce(l); }, d); })(perks[bk], di * 120); di++; } }
      }
      if (stage) stage.set(N / K.stackPer, true);
    }
    function stepBy(d) { set(steps[Math.max(0, Math.min(MAXI, idxOf(N) + d))], true); if (fire) fire.burst(); pingEls([cta, sticky && $('button', sticky)]); }

    range.addEventListener('input', function () { set(steps[+range.value], false); });
    range.addEventListener('change', function () {
      set(steps[+range.value], true);
      if (fire) fire.burst();
      pingEls([cta, sticky && $('button', sticky), D.querySelector('#cart-icon-bubble'), D.querySelector('.header__icon--cart')]);
    });
    minus.addEventListener('click', function () { stepBy(-1); });
    plus.addEventListener('click', function () { stepBy(1); });
    ticksEl.addEventListener('click', function (e) {
      var b = e.target.closest('.dwx-cfg__tick'); if (!b || b.classList.contains('is-off')) return;
      set(+b.getAttribute('data-n'), true);
    });

    if (ctx === 'product') {
      var cur = $('variant-selects input[type="radio"]:checked');
      var m = cur && K.rx.exec(cur.value);
      if (m) N = steps[idxOf((+m[1]) / K.div)];
    } else { N = steps[Math.min(2, MAXI)]; }
    paint();
    if (stage) {
      stage.set(N / K.stackPer, false);
      if (!REDUCE && 'IntersectionObserver' in W) {
        var sio = new IntersectionObserver(function (es) {
          if (es[0].isIntersecting) { sio.disconnect(); stage.playIn(); popAllOn(); }
        }, { threshold: 0.4 });
        sio.observe(stageHost);
      }
    }
    root.__dwxPlay = function () {
      if (lazyStage && !stage) { stage = new Stack(stageHost, packSrc, kind); lazyStage = false; stage.set(N / K.stackPer, false); }
      if (stage) stage.playIn();
      popAllOn();
    };
    DWX.gifts().then(function (g) {
      Object.keys(g).forEach(function (id) {
        if (+id === 60012806832512) gifts.poke = g[id];
      });
      paint();
    });

    function addDirect(v) {
      cta.disabled = true; var old = cta.textContent; cta.textContent = 'Wird hinzugefügt …';
      _fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] }) })
        .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
        .then(function () {
          DWX.refreshBubble();
          DWX.toast('<b>' + K.label(N) + '</b> liegen im Warenkorb <a href="/cart">Zum Warenkorb</a>');
          if (DWX.rewards) DWX.rewards.refresh(true);
        })
        .catch(function () { DWX.toast('Das hat nicht geklappt – bitte noch einmal versuchen.'); })
        .then(function () { cta.disabled = false; cta.textContent = old; paint(); });
    }
    if (cta && ctx === 'product') {
      /* Produktseite: den Dawn-Formular-Weg nutzen (Warenkorb-Meldung, Fehlerbehandlung), aber die richtige Variante vorher setzen */
      cta.addEventListener('click', function () {
        var v = map[N]; if (!v || !v.available) return;
        if (v.ext) { addDirect(v); return; }
        var form = $('product-form form') || $('form[action*="/cart/add"]');
        var idIn = form && $('input[name="id"]', form);
        var sub = form && ($('[type="submit"]', form) || $('button', form));
        if (!idIn || !sub) { W.location.href = '/cart/add?id=' + v.id + '&quantity=1&return_to=/cart'; return; }
        idIn.value = v.id;
        if (sub.getAttribute('aria-disabled') === 'true') sub.setAttribute('aria-disabled', 'false');
        sub.click();
        var old = cta.textContent; cta.disabled = true; cta.textContent = 'Wird hinzugefügt …';
        setTimeout(function () { cta.disabled = false; cta.textContent = old; paint(); }, 1600);
      });
    } else if (cta) {
      cta.addEventListener('click', function () { var v = map[N]; if (!v || !v.available) return; addDirect(v); });
    }
  }

  /* =====================================================================
     3) PRÄMIEN-LEISTE
     ===================================================================== */
  var RW = {
    tiers: [
      { min: 3000, v: 60012806799744, k: 'black', name: 'Schwarze Sleeves', unit: '100 Stück', ic: 'sleeves', lab: '30 €' },
      { min: 5000, v: 60012806832512, k: 'poke', name: '50 Pokémon-Karten', unit: 'Random-Booster', ic: 'cards', lab: '50 €' },
      { min: 10000, v: 60012806865280, k: 'tl', name: 'Toploader-Set', unit: '100 + 100', ic: 'toploader', lab: '100 €' }
    ],
    exclude: []
  };
  var rwRoot, rwEls = {}, rwState = { q: -1, unlocked: -1 }, rwTimer = 0, rwBusy = false, lastCart = null, gifts = {};
  var gids = RW.tiers.map(function (t) { return t.v; });

  function dismissed(v) { try { return sessionStorage.getItem('dwxRwX' + v) === '1'; } catch (e) { return false; } }
  function setDismissed(v, on) { try { if (on) sessionStorage.setItem('dwxRwX' + v, '1'); else sessionStorage.removeItem('dwxRwX' + v); } catch (e) {} }

  function qualifying(cart) {
    var q = 0;
    cart.items.forEach(function (i) {
      if (gids.indexOf(i.variant_id) > -1 || RW.exclude.indexOf(i.variant_id) > -1) return;
      q += i.original_line_price;
    });
    return q;
  }

  function fillPct(q) {
    var t = RW.tiers, seg = 100 / t.length, p = 0, prev = 0;
    for (var i = 0; i < t.length; i++) {
      if (q >= t[i].min) { p += seg; prev = t[i].min; continue; }
      p += seg * Math.max(0, (q - prev) / (t[i].min - prev)); break;
    }
    return Math.min(100, p);
  }

  function rwBuild() {
    rwRoot = D.createElement('div'); rwRoot.className = 'dwx-rw is-hidden';
    var nodes = '', chips = '';
    RW.tiers.forEach(function (t, i) {
      nodes += '<span class="dwx-rw__node" data-node="' + t.k + '" style="left:' + ((i + 1) / RW.tiers.length * 100) + '%">' + ICON[t.ic] + '<small>' + t.lab + '</small></span>';
      chips += '<div class="dwx-rw__gift" data-gift="' + t.k + '"><img alt="" width="38" height="38" loading="lazy"><div><b>' + t.name + '</b><em data-st>ab ' + t.lab + '</em></div></div>';
    });
    rwRoot.innerHTML =
      '<div class="dwx-rw__card" role="region" aria-label="Prämien-Fortschritt">' +
        '<div class="dwx-rw__top"><div class="dwx-rw__msg" data-msg aria-live="polite"></div><button type="button" class="dwx-rw__min" data-min aria-label="Leiste minimieren">&minus;</button></div>' +
        '<div class="dwx-rw__track"><div class="dwx-rw__fill" data-fill></div>' + nodes + '</div>' +
        '<div class="dwx-rw__gifts">' + chips + '</div>' +
      '</div>' +
      '<button type="button" class="dwx-rw__pill" data-pill>' + ICON.gift + '<span data-pilltxt></span></button>';
    D.body.appendChild(rwRoot);
    rwEls.msg = $('[data-msg]', rwRoot); rwEls.fill = $('[data-fill]', rwRoot); rwEls.pill = $('[data-pilltxt]', rwRoot);
    $('[data-min]', rwRoot).addEventListener('click', function () { setMin(true); });
    $('[data-pill]', rwRoot).addEventListener('click', function () { setMin(false); });
    rwRoot.querySelector('.dwx-rw__card').addEventListener('click', function (e) {
      if (e.target.closest('[data-min]')) return;
      if (W.innerWidth < 750) rwRoot.classList.toggle('is-open');
    });
  }
  /* Handy: die kleine Prämien-Pille weicht beim Runterscrollen aus und kommt beim Hochscrollen zurück */
  function rwScrollAway() {
    var lastY = W.scrollY, busy = false;
    W.addEventListener('scroll', function () {
      if (busy) return; busy = true;
      setTimeout(function () {
        busy = false; var y = W.scrollY, dy = y - lastY;
        if (Math.abs(dy) < 8) return; lastY = y;
        if (rwRoot) rwRoot.classList.toggle('is-away', dy > 0 && y > 200);
      }, 80);
    }, { passive: true });
  }
  function setMin(on) {
    rwRoot.classList.toggle('is-min', on);
    try { localStorage.setItem('dwxRwMin', on ? '1' : '0'); } catch (e) {}
  }
  function wasMin() { try { return localStorage.getItem('dwxRwMin') === '1'; } catch (e) { return false; } }
  function rwAutoMin() {
    clearTimeout(rwAutoMin.t);
    rwAutoMin.t = setTimeout(function () {
      if (!rwRoot || rwRoot.classList.contains('is-min')) return;
      if (rwRoot.matches(':hover') || rwRoot.classList.contains('is-open')) { rwAutoMin(); return; }
      setMin(true);
    }, 7000);
  }

  function burst(fromEl) {
    if (REDUCE || !fromEl || !fromEl.animate) return;
    var r = fromEl.getBoundingClientRect(), cx = r.left + r.width / 2, cy = r.top + r.height / 2;
    var box = D.createElement('div'); box.className = 'dwx-rw-burst'; D.body.appendChild(box);
    var cols = ['#ff4a5c', '#f5aa70', '#ffd27a', '#ffffff', '#5bd38a'];
    for (var i = 0; i < 28; i++) {
      var p = D.createElement('i'); p.style.left = cx + 'px'; p.style.top = cy + 'px'; p.style.background = cols[i % cols.length];
      box.appendChild(p);
      var a = Math.random() * Math.PI * 2, d = 70 + Math.random() * 150;
      p.animate([
        { transform: 'translate(0,0) rotate(0deg)', opacity: 1 },
        { transform: 'translate(' + Math.cos(a) * d + 'px,' + (Math.sin(a) * d - 60) + 'px) rotate(' + (Math.random() * 720 - 360) + 'deg)', opacity: 1, offset: 0.55 },
        { transform: 'translate(' + Math.cos(a) * d * 1.1 + 'px,' + (Math.sin(a) * d + 80) + 'px) rotate(' + (Math.random() * 900 - 450) + 'deg)', opacity: 0 }
      ], { duration: 1100 + Math.random() * 500, easing: 'cubic-bezier(.2,.7,.3,1)', fill: 'forwards' });
    }
    setTimeout(function () { box.remove(); }, 1800);
  }

  function rwRender(q, canPop) {
    var t = RW.tiers, prevUnlocked = rwState.unlocked;
    var unlocked = 0, nextT = null;
    t.forEach(function (x) { if (q >= x.min) unlocked++; });
    t.forEach(function (x) { var g = gifts[x.v]; var av = g ? g.available : true; if (!nextT && q < x.min && av) nextT = x; });

    rwEls.fill.style.width = fillPct(q).toFixed(1) + '%';
    t.forEach(function (x) {
      var g = gifts[x.v], av = g ? g.available : true, on = q >= x.min && av;
      var n = $('[data-node="' + x.k + '"]', rwRoot), c = $('[data-gift="' + x.k + '"]', rwRoot);
      n.classList.toggle('is-on', on); n.classList.toggle('is-soldout', !av);
      c.classList.toggle('is-on', on); c.classList.toggle('is-soldout', !av);
      $('[data-st]', c).textContent = !av ? 'gerade vergriffen' : (on ? 'gratis dabei' : 'ab ' + x.lab);
      var im = $('img', c); if (g && g.img && !im.getAttribute('src')) im.setAttribute('src', g.img.replace(/(\.[a-z]+)(\?|$)/i, '_120x120$1$2'));
    });

    var names = t.filter(function (x) { var g = gifts[x.v]; return q >= x.min && (g ? g.available : true); }).map(function (x) { return x.name; });
    var msg;
    if (q <= 0) msg = 'Sammle Gratis-Geschenke: ab <b>30 €</b> Warenwert gibt es <b>schwarze Sleeves</b> obendrauf.';
    else if (!nextT) msg = 'Alles freigeschaltet: <b>' + names.join(', ') + '</b> gehen aufs Haus.';
    else if (q < t[0].min) msg = 'Noch <b>' + eur(t[0].min - q) + '</b> bis <b>Gratis-Versand</b> und <b>schwarze Sleeves</b>.';
    else msg = '<b>' + names.join(' + ') + '</b> sind dabei. Noch <b>' + eur(nextT.min - q) + '</b> bis <b>' + nextT.name + '</b> gratis.';
    rwEls.msg.innerHTML = msg;
    rwEls.pill.textContent = !nextT ? 'Alle Geschenke dabei' : (q <= 0 ? 'Gratis-Geschenke ab 30 €' : 'Noch ' + eur(nextT.min - q) + ' bis Geschenk');

    /* Geschenk-Staffel-Sektion auf der Seite mitführen */
    $$('[data-dwx-tier]').forEach(function (el) {
      var min = +el.getAttribute('data-min'), v = +el.getAttribute('data-v'), g = gifts[v], av = g ? g.available : true;
      el.classList.toggle('is-on', q >= min && av); el.classList.toggle('is-soldout', !av);
      var st = $('[data-st]', el); if (st) st.textContent = !av ? 'Gerade vergriffen' : (q >= min ? 'Freigeschaltet' : 'Noch ' + eur(min - q));
    });
    $$('[data-dwx-gtfill]').forEach(function (el) { el.style.width = fillPct(q).toFixed(1) + '%'; });
    $$('[data-dwx-q]').forEach(function (el) { el.textContent = eur(q); });

    var first = rwState.q === -1;
    if (rwRoot.classList.contains('is-hidden')) {
      if (wasMin() || q <= 0 || D.documentElement.classList.contains('dwx-has-cfg') || /^\/cart/.test(W.location.pathname)) rwRoot.classList.add('is-min');
      setTimeout(function () { rwRoot.classList.remove('is-hidden'); }, first ? 900 : 0);
      if (!rwRoot.classList.contains('is-min')) rwAutoMin();
    }
    if (!first && q > rwState.q && canPop) {
      rwRoot.classList.remove('is-min', 'is-pop'); void rwRoot.offsetWidth; rwRoot.classList.add('is-pop');
      try { localStorage.setItem('dwxRwMin', '0'); } catch (e) {}
      setTimeout(function () { rwRoot.classList.remove('is-pop'); }, 1100);
      rwAutoMin();
    }
    if (!first && unlocked > prevUnlocked && prevUnlocked >= 0) {
      var tier = t[unlocked - 1], node = $('[data-node="' + tier.k + '"]', rwRoot), g2 = gifts[tier.v];
      if (!g2 || g2.available) {
        node.classList.remove('is-flare'); void node.offsetWidth; node.classList.add('is-flare');
        burst(node);
        popAt(node, tier.k, node);
        if (unlocked === 1) setTimeout(function () { popAt(node, 'ship', node); }, 320);
        DWX.toast('Freigeschaltet: <b>' + tier.name + '</b> gratis!');
      }
    }
    rwState.q = q; rwState.unlocked = unlocked;
  }

  function decorateGiftLines() {
    $$('a[href*="/products/gratisgeschenk"]').forEach(function (a) {
      var row = a.closest('.cart-item, tr, li'); if (row) row.classList.add('dwx-giftline');
    });
  }

  function reconcile(cart, q) {
    var inCart = {}; cart.items.forEach(function (i) { if (gids.indexOf(i.variant_id) > -1) inCart[i.variant_id] = i; });
    var ops = [];
    RW.tiers.forEach(function (t) {
      var g = gifts[t.v], av = g ? g.available : false;
      if (q < t.min) setDismissed(t.v, false);
      var want = q >= t.min && av && !dismissed(t.v), have = inCart[t.v];
      if (want && !have) ops.push({ add: t.v });
      else if (want && have && have.quantity !== 1) ops.push({ set: t.v, qty: 1, key: have.key });
      else if (!want && have) ops.push({ set: t.v, qty: 0, key: have.key });
    });
    if (!ops.length) return Promise.resolve(false);
    var chain = Promise.resolve(), okAny = false;
    ops.forEach(function (op) {
      chain = chain.then(function () {
        if (op.add) {
          return _fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: op.add, quantity: 1 }] }) })
            .then(function (r) { if (r.ok) okAny = true; else if (gifts[op.add]) gifts[op.add].available = false; });
        }
        return _fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: String(op.key || op.set), quantity: op.qty }) })
          .then(function (r) { if (r.ok) okAny = true; });
      });
    });
    return chain.then(function () { return okAny; });
  }

  function canReload() {
    try {
      var now = Date.now(), n = +sessionStorage.getItem('dwxRl') || 0, t = +sessionStorage.getItem('dwxRlT') || 0;
      if (now - t > 10000) n = 0;
      if (n >= 2) return false;
      sessionStorage.setItem('dwxRl', String(n + 1)); sessionStorage.setItem('dwxRlT', String(now));
    } catch (e) {}
    return true;
  }

  function refresh(canPop) {
    if (rwBusy) { rwTimer = setTimeout(function () { refresh(canPop); }, 250); return Promise.resolve(); }
    rwBusy = true;
    return DWX.gifts().then(function (g) { gifts = g; return DWX.cartJson(); }).then(function (cart) {
      lastCart = cart;
      var q = qualifying(cart);
      rwRender(q, canPop);
      return reconcile(cart, q).then(function (changed) {
        if (changed) {
          DWX.refreshBubble();
          if (W.location.pathname === '/cart' && canReload()) { W.location.reload(); }
        }
        decorateGiftLines(); setTimeout(decorateGiftLines, 700);
        D.dispatchEvent(new CustomEvent('dw:cart', { detail: { q: q } }));
      });
    }).catch(function () {}).then(function () { rwBusy = false; });
  }
  function schedule(canPop) { clearTimeout(rwTimer); rwTimer = setTimeout(function () { refresh(canPop); }, 140); }
  DWX.rewards = { refresh: schedule };

  function patchFetch() {
    if (!_fetch) return;
    W.fetch = function (input, init) {
      var p = _fetch.apply(W, arguments);
      try {
        var url = (typeof input === 'string' ? input : (input && input.url)) || '';
        if (/\/cart\/(add|change|update|clear)/.test(url)) {
          if (/\/cart\/change/.test(url) && init && typeof init.body === 'string' && lastCart) {
            try {
              var b = JSON.parse(init.body), it = null;
              if (b.quantity === 0 || b.quantity === '0') {
                if (b.line) it = lastCart.items[b.line - 1];
                else if (b.id) it = lastCart.items.filter(function (x) { return String(x.key) === String(b.id) || String(x.variant_id) === String(b.id); })[0];
                if (it && gids.indexOf(it.variant_id) > -1) setDismissed(it.variant_id, true);
              }
            } catch (e) {}
          }
          p.then(function () { schedule(true); }).catch(function () {});
        }
      } catch (e) {}
      return p;
    };
  }

  /* ---------- Bundles: mehrere Artikel mit einem Klick ---------- */
  function initBundles() {
    $$('[data-dwx-bundle]').forEach(function (b) {
      if (b.__dwx) return; b.__dwx = 1;
      b.addEventListener('click', function () {
        var items = b.getAttribute('data-dwx-bundle').split(',').map(function (x) { return { id: +x, quantity: 1 }; });
        b.disabled = true; var old = b.textContent; b.textContent = 'Wird hinzugefügt …';
        _fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
          .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
          .then(function () { DWX.refreshBubble(); DWX.toast('Bundle liegt im Warenkorb <a href="/cart">Zum Warenkorb</a>'); schedule(true); })
          .catch(function () { DWX.toast('Das hat nicht geklappt – bitte noch einmal versuchen.'); })
          .then(function () { b.disabled = false; b.textContent = old; });
      });
    });
  }

  /* ---------- Start ---------- */

  /* =====================================================================
     4) SHOP-KOMFORT: Karten mit Mengen-Regler führen zur Produktseite, fester Kauf-Balken für alle anderen Produkte
     ===================================================================== */
  var CFG_HANDLES = ['toploader-sleeves-set-3x4-fur-tcg-sammelkarten', 'card-sleeves-66-91-mm-2-5-3-5-perfect-fit-penny-sleeves', 'kartenhuellen-schwarz-66x91-mm-card-sleeves-tcg-sammelkarten', 'semi-rigid-card-saver-penny-sleeves-50-50'];
  function cardHandle(card) {
    var a = card && card.querySelector('a[href*="/products/"]'), m = a && /\/products\/([^\/?#]+)/.exec(a.getAttribute('href') || '');
    return m && m[1];
  }
  function relabelCards() {
    $$('.card-wrapper').forEach(function (card) {
      if (CFG_HANDLES.indexOf(cardHandle(card)) < 0) return;
      var b = $('.quick-add__submit', card); if (!b) return;
      for (var i = 0; i < b.childNodes.length; i++) {
        var nd = b.childNodes[i];
        if (nd.nodeType === 3 && nd.nodeValue.trim() && nd.nodeValue.trim() !== 'Menge wählen') { nd.nodeValue = ' Menge wählen '; break; }
      }
    });
  }
  function initCards() {
    D.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('.quick-add__submit'); if (!b) return;
      var h = cardHandle(b.closest('.card-wrapper'));
      if (CFG_HANDLES.indexOf(h) > -1) { e.preventDefault(); e.stopImmediatePropagation(); W.location.href = '/products/' + h; }
    }, true);
    relabelCards();
    var grid = D.getElementById('product-grid');
    if (grid && 'MutationObserver' in W) new MutationObserver(function () { relabelCards(); }).observe(grid, { childList: true, subtree: true });
  }

  /* Fester Kauf-Balken auch für Produkte ohne Regler (Handy und Desktop) */
  function initGenericSticky() {
    if (D.querySelector('[data-dwx-cfg]')) return;
    var sub = D.querySelector('product-info .product-form__submit, .product-form__submit');
    var h1 = D.querySelector('product-info h1, .product__title h1, h1');
    if (!sub || !h1 || !('IntersectionObserver' in W)) return;
    var bar = D.createElement('div'); bar.className = 'dwx-sticky'; bar.setAttribute('role', 'region'); bar.setAttribute('aria-label', 'Schnellkauf');
    bar.innerHTML = '<div class="dwx-sticky__txt"><b></b><span></span></div><button type="button" class="button button--primary">In den Warenkorb</button>';
    D.body.appendChild(bar);
    var btn = $('button', bar), tb = $('b', bar), ts = $('span', bar);
    function paintBar() {
      var pr = D.querySelector('product-info .price-item--sale, product-info .price-item--regular, .price .price-item--regular');
      tb.textContent = (h1.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 48);
      ts.textContent = pr ? pr.textContent.replace(/\s+/g, ' ').trim() : '';
      btn.disabled = sub.hasAttribute('disabled') || sub.getAttribute('aria-disabled') === 'true';
    }
    btn.addEventListener('click', function () { if (!btn.disabled) { sub.click(); pingEls([btn]); } });
    var io3 = new IntersectionObserver(function (es) {
      paintBar();
      var on = !es[0].isIntersecting && !btn.disabled;
      bar.classList.toggle('is-on', on); D.body.classList.toggle('dwx-sticky-on', on);
    }, { threshold: 0.6 });
    io3.observe(sub);
  }


  /* =====================================================================
     5) OBERFLÄCHE v6: Glut-Funken, Schräg-Kanten, Wasserzeichen, Tabs, Bundle-Effekte
     ===================================================================== */
  function Embers(host, o) {
    if (REDUCE || !host || !D.createElement('canvas').getContext) return;
    o = o || {};
    if (!SPR) SPR = [makeSprite(255, 205, 110), makeSprite(255, 120, 35), makeSprite(190, 35, 20)];
    var cv = D.createElement('canvas'); cv.className = 'dwx-embers'; cv.setAttribute('aria-hidden', 'true'); host.appendChild(cv);
    var cx = cv.getContext('2d'), parts = [], run = false, last = 0, vis = false, w = 0, h = 0, acc = 0, sk = 0;
    var rate = o.rate || 12, flames = !!o.flames;
    function size() {
      var r = host.getBoundingClientRect(), dpr = Math.min(1.5, W.devicePixelRatio || 1);
      w = Math.max(1, Math.round(r.width)); h = Math.max(1, Math.round(Math.min(r.height, o.height || 240)));
      sk = o.slant ? Math.max(22, Math.min(52, W.innerWidth * 0.034)) : 0;
      cv.width = Math.round(w * dpr); cv.height = Math.round(h * dpr); cv.style.width = w + 'px'; cv.style.height = h + 'px'; cx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }
    function edgeY(x) { var f = x / w; return h - sk * (o.dir === -1 ? f : 1 - f) - 2; }
    function spawn(n) {
      for (var i = 0; i < n; i++) {
        var x = Math.random() * w, fl = flames && Math.random() < 0.5, life = fl ? 0.9 + Math.random() * 0.9 : 2 + Math.random() * 2.2;
        parts.push({ x: x, y: edgeY(x) + Math.random() * 4, vx: (Math.random() - 0.5) * (fl ? 14 : 26), vy: -(fl ? 34 + Math.random() * 50 : 24 + Math.random() * 60), life: life, max: life, size: fl ? 9 + Math.random() * 12 : 1.6 + Math.random() * 3, fl: fl, seed: Math.random() * 6.28 });
      }
    }
    function frame(ts) {
      if (!run) return;
      var dt = Math.min(0.05, (ts - last) / 1000 || 0.016); last = ts;
      acc += rate * dt * (w / 900); var n = Math.floor(acc); acc -= n; if (parts.length < 150) spawn(n);
      cx.clearRect(0, 0, w, h); cx.globalCompositeOperation = 'lighter';
      for (var i = parts.length - 1; i >= 0; i--) {
        var p = parts[i]; p.life -= dt;
        if (p.life <= 0 || p.y < -20) { parts.splice(i, 1); continue; }
        var k = 1 - p.life / p.max; p.x += (p.vx + Math.sin(ts / 600 + p.seed) * 14) * dt; p.y += p.vy * dt;
        var s = p.size * (1 - k * 0.5), spr = k < 0.3 ? SPR[0] : (k < 0.7 ? SPR[1] : SPR[2]);
        cx.globalAlpha = Math.max(0, (p.fl ? 0.5 : 0.9) * (1 - k * k));
        cx.drawImage(spr, p.x - s, p.y - s * (p.fl ? 1.7 : 1), s * 2, s * (p.fl ? 3.4 : 2));
      }
      cx.globalAlpha = 1; requestAnimationFrame(frame);
    }
    function start() { if (run || !vis || D.hidden) return; run = true; last = performance.now(); size(); requestAnimationFrame(frame); }
    if ('IntersectionObserver' in W) {
      new IntersectionObserver(function (es) { vis = es[0].isIntersecting; if (vis) start(); else run = false; }, { threshold: 0.02 }).observe(host);
    }
    W.addEventListener('resize', function () { if (run) size(); });
    D.addEventListener('visibilitychange', function () { if (D.hidden) run = false; else start(); });
  }

  function initSurface() {
    var bands = $$('.dwx-band'), hw = $('.dwx-herowrap');
    if (!bands.length && !hw) return;
    D.body.insertAdjacentHTML('beforeend', '<svg width="0" height="0" style="position:absolute" aria-hidden="true" focusable="false"><defs><linearGradient id="dwx-seamg" x1="0" y1="0" x2="1" y2="0"><stop offset="0" stop-color="#c8203a"/><stop offset=".5" stop-color="#ff7a45"/><stop offset="1" stop-color="#ffd27a"/></linearGradient></defs></svg>');
    bands.forEach(function (b, i) {
      var dir = i % 2 ? -1 : 1, ln = dir === 1 ? '<line x1="0" y1="10" x2="100" y2="0"/>' : '<line x1="0" y1="0" x2="100" y2="10"/>';
      b.classList.add(dir === 1 ? 'dwx-band--sl' : 'dwx-band--sr');
      b.insertAdjacentHTML('afterbegin', '<i class="dwx-wm" aria-hidden="true"></i><svg class="dwx-seam dwx-seam--t" viewBox="0 0 100 10" preserveAspectRatio="none" aria-hidden="true">' + ln + '</svg><svg class="dwx-seam dwx-seam--b" viewBox="0 0 100 10" preserveAspectRatio="none" aria-hidden="true">' + ln + '</svg>');
      Embers(b, { slant: true, dir: dir, height: 190, rate: 9 });
    });
    if (hw) {
      hw.insertAdjacentHTML('afterbegin', '<i class="dwx-wm dwx-wm--hero" aria-hidden="true"></i>');
      Embers(hw, { height: 230, flames: true, rate: 24 });
    }
  }

  function initTabs() {
    $$('[data-dwx-tabs]').forEach(function (wrap) {
      var tabs = $$('[role="tab"]', wrap);
      var panels = tabs.map(function (t) { return D.getElementById(t.getAttribute('aria-controls')); });
      function show(i, focus) {
        tabs.forEach(function (t, j) {
          var on = j === i; t.setAttribute('aria-selected', on ? 'true' : 'false'); t.tabIndex = on ? 0 : -1; t.classList.toggle('is-on', on);
          if (panels[j]) panels[j].hidden = !on;
        });
        var root = panels[i] && $('[data-dwx-cfg]', panels[i]);
        if (root && root.__dwxPlay) setTimeout(root.__dwxPlay, 60);
        if (focus) tabs[i].focus();
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { show(i); });
        t.addEventListener('keydown', function (e) {
          var d = e.key === 'ArrowRight' ? 1 : (e.key === 'ArrowLeft' ? -1 : 0); if (!d) return;
          e.preventDefault(); show((i + d + tabs.length) % tabs.length, true);
        });
      });
    });
  }


  /* Zeigt unter dem Kauf-Button, welche Variante gerade gewählt ist (z. B. Handymodell) */
  function initSelectionNote() {
    if (D.documentElement.classList.contains('dwx-has-cfg')) return;
    var pf = D.querySelector('product-form'); if (!pf || !D.querySelector('variant-selects')) return;
    var note = D.createElement('p'); note.className = 'dwx-selnote'; note.setAttribute('aria-live', 'polite');
    pf.insertAdjacentElement('afterend', note);
    function read() {
      var vs = D.querySelector('variant-selects'), vals = [];
      if (!vs) return vals;
      $$('fieldset input[type="radio"]:checked', vs).forEach(function (i) { vals.push(i.value.trim()); });
      $$('select', vs).forEach(function (s) { if (s.options[s.selectedIndex]) vals.push(s.options[s.selectedIndex].text.trim()); });
      return vals;
    }
    function paint() {
      var v = read();
      if (!v.length) { note.style.display = 'none'; return; }
      note.style.display = '';
      note.textContent = 'Du kaufst: ';
      var b = D.createElement('b'); b.textContent = v.join(' · '); note.appendChild(b);
      var s = D.createElement('span'); s.textContent = ' – falsch? Oben eine andere Auswahl treffen.'; note.appendChild(s);
    }
    D.addEventListener('change', function (e) { if (e.target.closest && e.target.closest('variant-selects')) setTimeout(paint, 450); });
    paint();
  }

  function initBundleFx() {
    $$('.dwx-bd__card').forEach(function (el) {
      el.setAttribute('data-dwx-tilt', '');
      var raf = 0, rel = 0;
      function vars(rx, ry, mx, my, px, py) {
        el.style.setProperty('--rx', rx); el.style.setProperty('--ry', ry); el.style.setProperty('--mx', mx); el.style.setProperty('--my', my);
        el.style.setProperty('--px', px); el.style.setProperty('--py', py);
      }
      function move(e) {
        var r = el.getBoundingClientRect(), x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
        if (raf) return;
        raf = requestAnimationFrame(function () { raf = 0; vars(((0.5 - y) * 8).toFixed(2) + 'deg', ((x - 0.5) * 10).toFixed(2) + 'deg', (x * 100).toFixed(1) + '%', (y * 100).toFixed(1) + '%', (x - 0.5).toFixed(3), (y - 0.5).toFixed(3)); });
      }
      function hot(e) { clearTimeout(rel); el.classList.add('is-hot'); if (e) move(e); }
      function cool(delay) { clearTimeout(rel); rel = setTimeout(function () { el.classList.remove('is-hot'); vars('0deg', '0deg', '50%', '50%', '0', '0'); }, delay || 0); }
      el.addEventListener('pointerenter', hot);
      el.addEventListener('pointerdown', hot);
      el.addEventListener('pointermove', move);
      el.addEventListener('pointerleave', function (e) { cool(e.pointerType === 'mouse' ? 0 : 450); });
      el.addEventListener('pointerup', function (e) { if (e.pointerType !== 'mouse') cool(900); });
      el.addEventListener('pointercancel', function () { cool(300); });
    });
  }

  function start() {
    initFx();
    $$('[data-dwx-cfg]').forEach(initCfg);
    initBundles();
    initTilt();
    initBundleFx();
    try { initSelectionNote(); } catch (e) {}
    initTabs();
    initSurface();
    initCards();
    initGenericSticky();
    if (_fetch) { rwBuild(); patchFetch(); refresh(false); rwScrollAway(); }
    D.addEventListener('shopify:section:load', function () { $$('[data-dwx-cfg]').forEach(initCfg); });
  }
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', start); else start();
})();
